const languages = [
    {
      no: "16",
      name: "English",
      native: "English",
      code: "en",
    },
    {
      no: "27",
      name: "Hindi",
      native: "हिन्दी",
      code: "hi",
    },
    {
      no: "28",
      name: "Punjabi",
      native: "ਪੰਜਾਬੀ",
      code: "pa",
    },
    {
      no: "29",
      name: "Tamil",
      native: "தமிழ்",
      code: "ta",
    },
    {
      no: "30",
      name: "Bengali",
      native: "",
      code: "bn",
    },
    {
      no: "31",
      name: "Marathi",
      native: "",
      code: "mr",
    },
    {
      no: "32",
      name: "Telugu",
      native: "",
      code: "te",
    },
    {
      no: "33",
      name: "Assamese",
      native: "",
      code: "as",
    },
    {
      no: "34",
      name: "Kannada",
      native: "",
      code: "kn",
    },
    {
      no: "35",
      name: "Malayalam",
      native: "",
      code: "ml",
    },
    {
      no: "36",
      name: "Bhojpuri",
      native: "",
      code: "hi",
    },
    {
      no: "38",
      name: "Urdu",
      native: "",
      code: "ur",
    },
    {
      no: "39",
      name: "Odiya",
      native: "",
      code: "or",
    },
    {
      no: "40",
      name: "Gujarati",
      native: "",
      code: "gu",
    }
  ];

  export const getSpeechToTextLanguage = (langCode) => {
    const selectedLang = languages.filter(lang=> lang.name.toLowerCase() === (langCode==='bhojpuri'?'hindi':langCode))
    return selectedLang[0]
  }